module.exports = __webpack_public_path__ + "media/emails/notify-tenant-72d1e4b3.png";